import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: _normalizeClass({ active: $setup.value === 0 })
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "radio",
        value: 0,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.value) = $event))
      }, null, 512), [
        [_vModelRadio, $setup.value]
      ]),
      _createTextVNode(" " + _toDisplayString(_ctx.$t("position.left")), 1)
    ], 2),
    _createElementVNode("label", {
      class: _normalizeClass({ active: $setup.value === 1 })
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "radio",
        value: 1,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.value) = $event))
      }, null, 512), [
        [_vModelRadio, $setup.value]
      ]),
      _createTextVNode(" " + _toDisplayString(_ctx.$t("position.right")), 1)
    ], 2)
  ]))
}